import * as types from '../../mutation-types.js';
import http from '@service/http';
import util from '@common/utils/util';
import { tokenCall,restCall } from '@service/adapter';
import Constant from '@/Constant';
/**
 * 客户订单STORE
 */
export default {
  state: {
  },
  actions: {
 
    //账号密码注册
    saleRegister({commit},data){
      return tokenCall(Constant.tokenCallUrl+'/mxoa/sw/saleRegister',data,'get').then(res => {
        if (res.code == 200) {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject((res && res.message) || "获取数据失败");
        }
      }).catch(error => {
          return Promise.reject(error);
      }) 
    },
    //账号密码登录
    saleLogin({commit},data){
      return tokenCall(Constant.tokenCallUrl+'/mxoa/sw/saleLogin',data,'get').then(res => {
        if (res.code == 200) {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject((res && res.message) || "获取数据失败");
        }
      }).catch(error => {
          return Promise.reject(error);
      }) 
    },
    //安装队申请
    addTeam({commit},data){
      return tokenCall(Constant.tokenCallUrl+'/mxoa/sale/team/addTeam',data,'post').then(res => {
        if (res.code == 200) {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject((res && res.message) || "获取数据失败");
        }
      }).catch(error => {
          return Promise.reject(error);
      }) 
    },

    //分页查询安装队 物流订单信息
    pagelogisticsOrder({commit},data){
      return tokenCall(Constant.tokenCallUrl+'/mxoa/saleInstall/pagelogisticsOrder',data,'post').then(res => {
        if (res.code == 200) {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject((res && res.message) || "获取数据失败");
        }
      }).catch(error => {
          return Promise.reject(error);
      }) 
    },

    //物流详细订单
    getLogisticsOrder({commit},data){
      return tokenCall(Constant.tokenCallUrl+'/mxoa/saleInstall/getLogisticsOrder',data,'get').then(res => {
        if (res.code == 200) {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject((res && res.message) || "获取数据失败");
        }
      }).catch(error => {
          return Promise.reject(error);
      }) 
    },

    //物流进度
    addTeamProcess({commit},data){
      return tokenCall(Constant.tokenCallUrl+'/mxoa/saleInstall/addTeamProcess',data,'post').then(res => {
        if (res.code == 200) {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject((res && res.message) || "获取数据失败");
        }
      }).catch(error => {
          return Promise.reject(error);
      }) 
    },

    //确认收货
    receiveOrder({commit},data){
      return tokenCall(Constant.tokenCallUrl+'/mxoa/saleInstall/receiveOrder',data,'post').then(res => {
        if (res.code == 200) {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject((res && res.message) || "获取数据失败");
        }
      }).catch(error => {
          return Promise.reject(error);
      }) 
    },

    //获取售后订单信息 操作日志 
    selectOrderLogs({commit},data){
      return tokenCall(Constant.tokenCallUrl+'/mxoa/sale/selectOrderLogs',data,'get').then(res => {
        if (res.code == 200) {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject((res && res.message) || "获取数据失败");
        }
      }).catch(error => {
          return Promise.reject(error);
      }) 
    },


  },
  mutations: {
  },
  getters: {
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/fitting/index.js